<div class="account-item" [attr.data-test-id]="testId">
  <div
    class="item-header"
    [class.item-header--wrap]="autoPayEnrollment()?.kind === 'skipped'"
  >
    <span class="item-header__title" (click)="onTitleClick.emit()">{{
      accountTitle()
    }}</span>

    @if (
      showAutoPay() &&
      accountStatus() !== 'Closed' &&
      accountStatus() !== 'Paid in Full'
    ) {
      <div>
        <div
          class="autopay"
          tabindex="0"
          (focus)="setIsShowAutoPayTooltipFocused(true)"
          (blur)="setIsShowAutoPayTooltipFocused(false)"
          (mouseenter)="setIsShowAutoPayTooltipHovered(true)"
          (mouseleave)="setIsShowAutoPayTooltipHovered(false)"
        >
          <div>
            <span class="autopay__label">Auto pay:</span>
            @if (!autoPayEnrollment()) {
              <span class="autopay__status-loading" aria-busy="true">
                <app-loading-icon
                  size="sm"
                  svgAriaLabel="Loading auto pay status"
                ></app-loading-icon>
              </span>
            } @else {
              @if (autoPayEnrollment(); as enrollment) {
                @switch (enrollment.kind) {
                  @case ('notEnrolled') {
                    <span [class]="autopayStatusClass()">OFF</span>
                  }
                  @case ('enrolled') {
                    <span [class]="autopayStatusClass()">ON</span>
                  }
                  @case ('skipped') {
                    <span [class]="autopayStatusClass()">
                      Resumes
                      {{ enrollment.resumesOnIso | date: 'MMM d, yyyy' }}
                    </span>
                  }
                  @default {
                    <span [class]="autopayStatusClass()">OFF</span>
                  }
                }
              }
            }
          </div>
          <span class="autopay__info-icon">
            <app-icon-info
              [width]="'12'"
              [height]="'12'"
              [color]="'#36445E'"
            ></app-icon-info>
          </span>
        </div>
        <div class="auto-pay-tooltip">
          @if (
            isShowAutoPayTooltipFocused || (isShowAutoPayTooltipHovered | async)
          ) {
            <app-be-tooltip
              @fadeInOut
              [direction]="'down'"
              (mouseleave)="setIsShowAutoPayTooltipHovered(false)"
              id="autoPayTooltip"
            >
              <p class="be-text-xs text-white">
                Never worry about missing a payment again. With auto pay, your
                payments are made on time, every time.
              </p>
            </app-be-tooltip>
          }
        </div>
      </div>
    }
  </div>
  <div class="account-status">
    <span [class]="statusClass()">{{ statusText() }}</span>
  </div>
  <ng-content></ng-content>
</div>
